/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Preview_Pane_BrokersInputs */

const cs_import_preview_pane_brokers = /** @type {(inputs: Import_Preview_Pane_BrokersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makléři`)
};

const en_import_preview_pane_brokers = /** @type {(inputs: Import_Preview_Pane_BrokersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brokers`)
};

/**
* | output |
* | --- |
* | "Brokers" |
*
* @param {Import_Preview_Pane_BrokersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_preview_pane_brokers = /** @type {((inputs?: Import_Preview_Pane_BrokersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Preview_Pane_BrokersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_preview_pane_brokers(inputs)
	return cs_import_preview_pane_brokers(inputs)
});